import { render } from "./EntitlementBulkUpdateModal.vue?vue&type=template&id=c94a08c2&scoped=true"
import script from "./EntitlementBulkUpdateModal.vue?vue&type=script&lang=js"
export * from "./EntitlementBulkUpdateModal.vue?vue&type=script&lang=js"

import "./EntitlementBulkUpdateModal.vue?vue&type=style&index=0&id=c94a08c2&lang=scss&scoped=true"

import exportComponent from "/var/www/html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94a08c2"]])

export default __exports__